import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Seo from "./components/seo/Seo";


import { useDispatch, useSelector } from 'react-redux'; // Importe useSelector
import { fetchConfig } from './redux/configSlice';
import { updateUser, clearUser } from './redux/userSlice';
import API from './api';
// Layouts
import AppLayout from './layouts/AppLayout';
// Routes Components
import HomeDefault from './pages/homes/HomeDefault';
import HomeMain from './pages/homes/HomeMain';
import HomeDev from './pages/homes/HomeDev';
import HomeAdmin from './pages/homes/HomeAdmin';
/** FORMALITES - FRONT **/
import PageFormalitiesTemplates from 'pages/formalities/PageFormalitiesTemplates';
import PageFormalityRequest from 'pages/formalities/PageFormalityRequest';
// import PageFormalitiesRequests from 'pages/formalities/PageFormalitiesRequests';
/** FORMALITES - ADMIN - TEMPLATES **/
import AdminPageFormalitiesTemplatesList from 'pages/formalities/admin/AdminPageFormalitiesTemplatesList';
import AdminPageFormalitiesTemplateBuilder from 'pages/formalities/admin/AdminPageFormalitiesTemplateBuilder';
import AdminPageFormalitiesTemplatesCategories from './pages/formalities/admin/AdminPageFormalitiesTemplatesCategories';
/** FORMALITES - ADMIN - REQUESTS **/
import AdminPageFormalitiesRequestsList from './pages/formalities/admin/AdminPageFormalitiesRequestsList';
import AdminPageFormalityRequest from './pages/formalities/admin/AdminPageFormalityRequest';
import AdminPageFormalitiesPricings from 'pages/formalities/admin/AdminPageFormalitiesPricings';
/** FORMALITES - ADMIN - ADMIN **/
import AdminParameters from './components/admin/AdminParameters';
/*** USERS & CUSTOMERS ***/
import PageCustomerAccount from 'pages/customers/PageCustomerAccount';
import PageAdminCustomersList from './pages/customers/admin/PageAdminCustomersList';
/*** ORDERS ***/
import PageAdminOrdersList from './pages/orders/admin/PageAdminOrdersList';
import PageCMS from 'pages/cms/PageCMS';


/** ORDER FRONT */
import PageOrderPay from "pages/orders/PageOrderPay";


/** Cart */
import PageCart from 'pages/cart/PageCart';


/** CONTACT */
import PageContact from 'pages/contact/PageContact';



// Styles 
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './css/app.css';
import './css/colors.css';
import './css/modals.css';

// Route Definitions
const routes = [
  { path: "/", element: <HomeDefault /> },
  { path: "/home", element: <HomeMain />, requireAuth: true },
  { path: "/home-dev", element: <HomeDev />, requireAdmin: true },
  /** CMS */
  { path: "/cms/:page", element: <PageCMS />, requireAuth: false },

  /** FORMALITES - FRONT */
  { path: "/formalities/templates", element: <PageFormalitiesTemplates />, requireAuth: false },
  { path: "/formalities/templates/:catId", element: <PageFormalitiesTemplates />, requireAuth: false },
  { path: "/formalities/request/:slug/:version", element: <PageFormalityRequest />, requireAuth: false },
  { path: "/formalities/request/create/:tplId", element: <PageFormalityRequest />, requireAuth: false },
  { path: "/formalities/request/edit/:reqId", element: <PageFormalityRequest />, requireAuth: false },
  { path: "/formalities/request/:reqId", element: <PageFormalityRequest />, requireAuth: false },
  /** FORMALITES - ADMIN */
  { path: "/admin/formalities/templates/list", element: <AdminPageFormalitiesTemplatesList />, requireAdmin: true },
  { path: "/admin/formalities/template/builder/:tplId", element: <AdminPageFormalitiesTemplateBuilder />, requireAdmin: true },
  { path: "/admin/formalities/templates/categories", element: <AdminPageFormalitiesTemplatesCategories />, requireAdmin: true },
  { path: "/admin/formalities/requests/list", element: <AdminPageFormalitiesRequestsList />, requireAdmin: true },
  { path: "/admin/formalities/request/:frId", element: <AdminPageFormalityRequest />, requireAdmin: true },
  { path: "/admin/formalities/pricings", element: <AdminPageFormalitiesPricings />, requireAdmin: true },
  { path: "/admin/admin/parameters", element: <AdminParameters />, requireAdmin: true },
  /** CUSTOMER - FRONT */
  { path: "/customer/account", element: <PageCustomerAccount />, requireAuth: true },
  { path: "/customer/account/*", element: <PageCustomerAccount />, requireAuth: true },
  { path: "/customer/orders", element: <PageCustomerAccount />, requireAuth: true },

  /** CUSTOMERS BACKOFFICE  */
  { path: "/admin/customers", element: <PageAdminCustomersList />, requireAdmin: true },
  /*
  /** ADMIN - FRONT */
  { path: "/admin", element: <HomeAdmin />, requireAdmin: true },
  /** ORDER FRONT PAYMPENT  */
  { path: "/orders/pay/:token", element: <PageOrderPay />, requireAuth: false },
  /** ORDER BACKOFFICE  */
  { path: "/admin/orders", element: <PageAdminOrdersList />, requireAdmin: true },
  { path: "/admin/orders/:orderId", element: <PageAdminOrdersList />, requireAdmin: true },

  /** CART */
  { path: "/cart", element: <PageCart />, requireAuth: true },


  /** CONTACT */
  { path: "/contact", element: <PageContact />, requireAuth: false },
];

function AppSeo({ seoPages }) {

  const location = useLocation();

  const seo = seoPages[location.pathname] || null;

  return <Seo seo={seo} />;
}

function App() {
  const user = useSelector((state) => state.user);
  const [seoPages, setSeoPages] = useState({});
  const dispatch = useDispatch();
  const [allowed, setAllowed] = useState(false);
  useEffect(() => {
    fetch("/seo-pages.json?v=" + Date.now())
      .then((res) => res.json())
      .then((data) => setSeoPages(data))
      .catch(() => setSeoPages({}));
  }, []);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const adminAuthToken = params.get('adminAuthToken');
    if (adminAuthToken) {
      checkToken(adminAuthToken, params.get('userId'));
    } else {
      setAllowed(true);
    }
    // Setup message listener
    const handleMessage = (event) => {

      if (event.data && event.data.type === 'userSignOut') {
        dispatch(clearUser());
      }
    };
    window.addEventListener("message", handleMessage);
    // Cleanup listener on unmount
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  useEffect(() => {
    dispatch(fetchConfig());
  }, [dispatch]);
  const checkToken = async (adminAuthToken, userId) => {
    let querystring = 'adminAuthToken=' + adminAuthToken;
    querystring += '&userId=' + userId;

    const response = await API.get('/admin/signin?' + querystring);
    if (response.data.isAdmin == true) {
      setAllowed(true)
      window.localStorage.setItem('adminToken', response.data.token);
      dispatch(updateUser(response.data));
      window.sessionStorage.setItem('backoffice_url', '/appAdmin');
      window.location.href = '/extradmin';
    } else {
      window.location.href = '/';
    }
  }
  let windowHeight = document.documentElement.scrollHeight
  if (window !== window.parent) {
    /*
    window.setInterval(() => {
      var element = document.getElementById('root');
      var rect = element.getBoundingClientRect();
      if (windowHeight != rect.height) {
        windowHeight = rect.height;
        window.parent.postMessage({ windowHeight: windowHeight }, 'https://laffairearepasser.fr');
      }
    }, 1000);
    */
  }
  /* basename={getBasename(window.location.pathname)} */
  return (
    <>
      {allowed &&
        <Router>
          <AppSeo seoPages={seoPages} />
          <Routes>
            {routes.map((route) => (
              <Route key={route.path}
                path={route.path}
                element={<AppLayout requireAuth={route.requireAuth} requireAdmin={route.requireAdmin} config={route.config ? route.config : {}}>
                  {route.element}
                </AppLayout>}
              />
            ))}
          </Routes>
        </Router>
      }
    </>
  );
}
export default App;
